import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../App';

function Footer() {
  const { t, linkPrefix } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to={linkPrefix || '/'} className="logo" style={{ color: '#14b8a6' }}>
              <span className="logo-icon">👨‍🍳</span>
              <span>Chefyz</span>
            </Link>
            <p>{t.footer.description}</p>
          </div>

          <div className="footer-section">
            <h4>{t.footer.legal}</h4>
            <Link to={`${linkPrefix}/privacy`}>{t.nav.privacy}</Link>
            <Link to={`${linkPrefix}/terms`}>{t.nav.terms}</Link>
            <Link to={`${linkPrefix}/data-deletion`}>{t.nav.dataDeletion}</Link>
          </div>

          <div className="footer-section">
            <h4>{t.footer.contact}</h4>
            <Link to={`${linkPrefix}/support`}>{t.nav.support}</Link>
            <a href="mailto:support@chefyz.ai">support@chefyz.ai</a>
          </div>

          <div className="footer-section">
            <h4>{t.footer.downloadApp || 'Download'}</h4>
            <a href="https://apps.apple.com/tr/app/chefyz/id6757770703" className="badge-btn badge-btn-footer" target="_blank" rel="noopener noreferrer">
              <span className="badge-apple-logo" aria-hidden="true"></span>
              <div className="badge-btn-text">
                <span>Download on the</span>
                <strong>App Store</strong>
              </div>
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.buse59299.chefyz" className="badge-btn badge-btn-footer" target="_blank" rel="noopener noreferrer">
              <span className="badge-play-logo" aria-hidden="true">▶</span>
              <div className="badge-btn-text">
                <span>Get it on</span>
                <strong>Google Play</strong>
              </div>
            </a>
          </div>

          <div className="footer-section">
            <h4>{t.footer.followUs}</h4>
            <div className="social-links">
              <a href="https://twitter.com/chefyzapp" target="_blank" rel="noopener noreferrer" className="social-link">
                𝕏
              </a>
              <a href="https://instagram.com/chefyzapp" target="_blank" rel="noopener noreferrer" className="social-link">
                📷
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {currentYear} Chefyz. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
